/**
 * Changelog ID: TCC-A11Y-001
 * Author: Cascade AI
 * Date: 2025-05-27
 * Summary: Global accessibility fixes for dynamic content
 * Following WindSurf Global Rules for accessibility requirements
 */

/**
 * Adds missing accessibility attributes to dynamically created elements
 * Particularly focuses on fixing iframes without title attributes
 */
export function initAccessibilityFixes() {
  // Fix for iframes without titles (including webpack-dev-server-client-overlay)
  const fixIframesWithoutTitles = () => {
    const iframes = document.querySelectorAll('iframe:not([title])');
    
    iframes.forEach(iframe => {
      // Check if it's the webpack dev overlay
      if (iframe.id === 'webpack-dev-server-client-overlay') {
        iframe.setAttribute('title', 'Webpack Development Overlay');
      } else {
        // For other iframes, set a generic but meaningful title
        iframe.setAttribute('title', 'Application Content Frame');
      }
    });
  };

  // Run immediately
  fixIframesWithoutTitles();
  
  // Set up a MutationObserver to handle dynamically added iframes
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        fixIframesWithoutTitles();
      }
    });
  });
  
  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Clean up function to disconnect the observer when needed
  return () => observer.disconnect();
}
